<template>
  <div>
    <div class="columns is-multiline">
      <div
        v-for="(item, i) in items"
        :key="i"
        class="column is-one-third"
      >
        <h4 class="title is-6">{{ item.title }}</h4>
        
        <div style="position:relative; height:220px;">
          <canvas :ref="'bar'+i"></canvas>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
Chart.plugins.unregister(ChartDataLabels);
Chart.plugins.register(ChartDataLabels);
export default {
  name: "ResultsBars",

  props: {
    items: {
      type: Array,
      required: true
    },
    maxValue: {
      type: Number,
      required: true
    },
    steps: {
      type: Number,
      required: false
    }

  },

  data() {
    return { charts: [] };
  },

  watch: {
    items: {
      deep: true,
      handler() {
        this.charts.forEach(c => c.destroy && c.destroy());
        this.charts = [];
        this.$nextTick(() => {
          this.items.forEach((item, i) => this.renderChart(item, i));
        });
      }
    }
  },

  mounted() {
    // Extensión → barras con bordes redondeados
    this.extendRoundedBars();

    // Extensión → leyenda con esquinas redondeadas
    // this.extendRoundedLegend();

    // Renderizar gráficos
    this.items.forEach((item, i) => this.renderChart(item, i));

    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this._resizeTimer) {
      clearTimeout(this._resizeTimer);
    }
    this.charts.forEach(c => c.destroy && c.destroy());
  },

  methods: {
    handleResize() {
      if (this._resizeTimer) {
        clearTimeout(this._resizeTimer);
      }
      this._resizeTimer = setTimeout(() => {
        if (this.$el && this.$el.offsetParent !== null) {
          this.charts.forEach(c => {
            if (c && c.resize) {
              c.resize();
              c.update();
            }
          });
        }
      }, 150);
    },

    /* ============================================================
       1. EXTENSIÓN PARA BARRAS REDONDEADAS
    ============================================================ */
    extendRoundedBars() {
      Chart.elements.Rectangle.prototype.draw = function () {
        const ctx = this._chart.ctx;
        const vm = this._view;
        const left = vm.x - vm.width / 2;
        const right = vm.x + vm.width / 2;
        const top = vm.y;
        const bottom = vm.base;
        const radius = 2;

        ctx.beginPath();
        ctx.fillStyle = vm.backgroundColor;

        // Barra con esquinas superiores redondeadas
        ctx.moveTo(left, bottom);
        ctx.lineTo(left, top + radius);
        ctx.quadraticCurveTo(left, top, left + radius, top);
        ctx.lineTo(right - radius, top);
        ctx.quadraticCurveTo(right, top, right, top + radius);
        ctx.lineTo(right, bottom);
        ctx.closePath();
        ctx.fill();
      };
    },


    /* ============================================================
       2. CREACIÓN DEL GRÁFICO
    ============================================================ */
    renderChart(item, index) {
      const ctx = this.$refs["bar" + index];
      if (!ctx) return;

      const labels = ["Colaboración", "Creación", "Competencia", "Control"];
      
      let STEP_SIZE = this.steps? this.steps: 20;

      // Redondea al múltiplo de 10 más cercano
      const roundedMax = Math.ceil(this.maxValue / STEP_SIZE) * STEP_SIZE || STEP_SIZE;

      const chart = new Chart(ctx, {
        type: "bar",
        data: {
          labels,
          datasets: [
            {
              label: "Actual",
              data: item.actual.map(Number),
              backgroundColor: '#DC8FB5'// "#D04E8C99"
            },
            {
              label: "Deseada",
              data: item.deseada.map(Number),
              backgroundColor: '#8EB8E9'// "#4A90E299"
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            labels: {
              padding: 18,
              fontSize: 12
            }
          },
          scales: {
            yAxes: [
              {
                gridLines: {
                  color: "rgba(0,0,0,0.08)",   // grid más suave
                  zeroLineColor: "rgba(0,0,0,0.25)"
                },
                ticks: {
                  beginAtZero: true,
                  max: roundedMax,
                  stepSize: STEP_SIZE,
                  callback: v => `${v}%`
                }
              }
            ],
            xAxes: [
              {
                gridLines: {
                  display: false
                }
              }
            ]
          },
          plugins: {
            datalabels: {
              color: "#1E293B",   // 👈 color del texto encima de la barra
              font: {
                weight: "400",
                size: 11
              },
              anchor: "end",
              align: "end",
              offset: -4,
              clamp: true,
              formatter: value => `${value}%`
            }
          }
        }
      });

      this.charts.push(chart);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cultura/sections/results/ResultsBars.vue